/**
 * Existing backend roles ONLY.
 * Do not invent additional roles.
 */
export const ROLES = {
  SUPERADMIN: 'superadmin',
  ADMIN: 'admin',
  MANAGER: 'manager',
  TEAM_LEAD: 'team_lead',
  BDE: 'bde',
  DEVELOPER: 'developer',
  EMPLOYEE: 'employee',
} as const;

export type Role = (typeof ROLES)[keyof typeof ROLES];

/**
 * The app's API returns roles as SUPERADMIN / OWNER / ADMIN / MEMBER / VIEWER, while the
 * migrated permission code was written against the lowercase set above. Compare through
 * this instead of `user.role === 'superadmin'` so both spellings work:
 * OWNER counts as a superadmin (as isSuperAdminOrOwner does), MEMBER/VIEWER as an employee.
 */
export function roleKey(role?: string | null): string {
  const r = String(role ?? '').trim().toLowerCase();
  if (r === 'owner') return ROLES.SUPERADMIN;
  if (r === 'member' || r === 'viewer') return ROLES.EMPLOYEE;
  return r;
}

export const isSuperadminRole = (role?: string | null) => roleKey(role) === ROLES.SUPERADMIN;
